import script from "./RelatedGamesSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelatedGamesSelector.vue?vue&type=script&setup=true&lang=ts"

import "./RelatedGamesSelector.vue?vue&type=style&index=0&id=cab3959a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cab3959a"]])

export default __exports__